<template>
  <footer class="app-footer">
    <div class="footer__content">
      <div class="footer__row">
        <div class="footer__social">
          <div class="footer__partners">
            <span>With the support of</span>
            <div class="footer__partners-list">
              <a href="https://www.escoe.ac.uk/" class="footer__partner-link" target="_blank" rel="noopener noreferrer">
                <img src="https://www.oecd.org/content/dam/going-digital-toolkit/images/home-logos/escoe_logo.svg"
                  alt="ESCoE logo" loading="lazy">
              </a>
              <a href="https://www.ons.gov.uk/" class="footer__partner-link" target="_blank" rel="noopener noreferrer">
                <img src="https://www.oecd.org/content/dam/going-digital-toolkit/images/home-logos/ons_logo.svg"
                  alt="ONS logo" loading="lazy">
              </a>
              <a href="https://www.statcan.gc.ca/" class="footer__partner-link" target="_blank"
                rel="noopener noreferrer">
                <img src="https://www.oecd.org/content/dam/going-digital-toolkit/images/home-logos/statcan_logo.svg"
                  alt="StatCan logo" loading="lazy">
              </a>
              <a href="https://nic.br/" class="footer__partner-link" target="_blank" rel="noopener noreferrer">
                <img src="https://www.oecd.org/content/dam/going-digital-toolkit/images/home-logos/nic-br_logo.svg"
                  alt="nic.br logo" loading="lazy">
              </a>
              <a href="https://www.bea.gov/" class="footer__partner-link" target="_blank" rel="noopener noreferrer">
                <img src="https://www.oecd.org/content/dam/going-digital-toolkit/images/home-logos/bea-logo.svg"
                  alt="logo BEA" loading="lazy">
              </a>
              <a href="https://www.cbs.gov.il" target="_blank" rel="noopener noreferrer" class="footer__partner-link">
                <img src="https://www.oecd.org/content/dam/going-digital-toolkit/images/home-logos/cbs_logo.svg"
                  alt="CBS logo" loading="lazy">
              </a>
            </div>
          </div>
          <div class="footer__collaborators">
            <span>Designed and created by</span>
            <div class="footer__collaborators-list">
              <a href="https://www.bestiario.org" class="footer__collaborator-link" target="_blank"
                rel="noopener noreferrer">
                <img src="@/assets/images/logo-bestiario.svg" alt="logo Bestiario" loading="lazy"
                  style="filter: invert(1)">
              </a>
            </div>
          </div>
        </div>
      </div>
      <div class="footer__row">
        <div class="footer__contact">
          <a href="https://www.oecd.org/termsandconditions/">Terms and Conditions</a>
          <a href="https://www.oecd.org/privacy/">Privacy Policy</a>
          <a href="mailto:GoingDigitalToolkit@oecd.org">Contact Us</a>
        </div>
        <div class="footer__social-networks">
          <span>Follow us on:</span>
          <a href="https://twitter.com/OECDinnovation">
            <svg width="17" height="16" viewBox="0 0 17 16">
              <g clip-path="url(#clip0_2_2)">
                <path
                  d="M13.3885 0H15.9951L10.3002 6.77754L17 16H11.754L7.64538 10.4065L2.94409 16H0.33565L6.42693 8.75079L0 0H5.37887L9.09284 5.11254L13.3885 0ZM12.4735 14.3753H13.918L4.59408 1.5394H3.04416L12.4735 14.3753Z"
                  fill="currentColor" />
              </g>
              <defs>
                <clipPath id="clip0_2_2">
                  <rect width="17" height="16" fill="currentColor" />
                </clipPath>
              </defs>
            </svg>
          </a>
          <a href="https://www.facebook.com/theOECD/">
            <svg width="24" height="24" viewBox="0 0 24 24">
              <path fill="currentColor" fill-rule="evenodd"
                d="M16.2 6.7h-1.5c-1.2 0-1.4.6-1.4 1.4v1.8h2.8l-.4 2.8h-2.4V20h-2.9v-7.3H7.9V9.9h2.5V7.8C10.3 5.3 11.8 4 14 4c1 0 1.9.1 2.2.1v2.6z" />
            </svg>
          </a>
          <a
            href="https://www.linkedin.com/company/organisation-eco-cooperation-development-organisation-cooperation-developpement-eco">
            <svg width="24" height="24" viewBox="0 0 24 24">
              <path fill="currentColor"
                d="M19.205 4H4.695C4.299 4 4 4.3 4 4.7v14.7c0 .3.298.6.696.6h14.608c.398 0 .696-.3.696-.7V4.7c-.1-.4-.398-.7-.795-.7zM8.671 17.6H6.385V10H8.77v7.6h-.1zM7.578 9c-.795 0-1.392-.7-1.392-1.4 0-.8.597-1.4 1.392-1.4.795 0 1.39.6 1.39 1.4-.098.7-.695 1.4-1.39 1.4zm9.938 8.6H15.13v-3.7c0-.9 0-2-1.192-2-1.193 0-1.391 1-1.391 2v3.8H10.16V10h2.286v1c.298-.6 1.093-1.2 2.187-1.2 2.385 0 2.782 1.6 2.782 3.6v4.2h.1z" />
            </svg>
          </a>
        </div>
      </div>
      <div class="footer__row">© 2022 OECD. All rights reserved.</div>
    </div>
  </footer>
</template>

<script>
export default {
  data() {
    return {}
  }
}
</script>

<style lang="stylus">
.app-footer
	padding: 32px 0
	margin-top: 8px
	background-color: #06838f
	color: white

	+m-breakpoint(xmd)
		padding: 65px 0

.footer__content
	margin: 0 auto
	padding: 0 24px
	max-width: 1440px

	+m-breakpoint(xmd)
		padding: 0px 48px
		max-width: 1488px

	+m-breakpoint(xlg)
		padding: 0 62px
		max-width: 1516px

.footer__row
	&:nth-child(2)
		padding: 65px 0 0

		+m-breakpoint(xmd)
			display: flex
			justify-content: space-between
			align-items: flex-start
			padding: 92px 0 0
	
	&:last-child
		font-family: 'Bernini Sans', 'Helvetica Neue', Helvetica, Arial, serif
		font-weight: 400
		font-style: normal
		font-size: 14px
		line-height: 18px
		color: rgba(255,255,255,0.75)
		margin-top: 32px

		+m-breakpoint(xmd)
			margin-top: 24px

.footer__social
	+m-breakpoint(xmd)
		display: flex

.footer__partners
.footer__collaborators
	padding: 40px 0 0 0

	+m-breakpoint(xmd)
		padding: 0 40px 0 0

		.footer__partners-list
			display: flex
			align-items: flex-end

	> span
		display: block;
		font-family: 'Bernini Sans', 'Helvetica Neue', Helvetica, Arial, serif
		font-weight: 400
		font-style: normal
		font-size: 12px
		line-height: 16px
		color: rgba(255,255,255,0.75)
		margin-bottom: 12px

.footer__partner-link
.footer__collaborator-link
	margin: 0 0 16px 0
	text-decoration: none
	display: block

	+m-breakpoint(xmd)
		margin: 0 24px 0 0

	> img
		height: 40px

.footer__collaborator-link
	> img
		margin-top: 5px
		height: 30px

.footer__contact
	+m-breakpoint(xmd)
		display: flex
		justify-content: space-between
		align-items: flex-start

		> a
			border-bottom: none !important

			+ a
				margin-left: 40px

	> a
		font-family: 'Bernini Sans', 'Helvetica Neue', Helvetica, Arial, serif
		font-weight: 400
		font-style: normal
		font-size: 14px
		line-height: 18px
		line-height: 24px
		color: rgba(255,255,255,0.75)
		text-decoration: none
		transition: all 120ms cubic-bezier(0.4, 0.0, 0.2, 1)
		display: block
		padding: 8px 0
		border-bottom: 1px solid rgba(255, 255, 255, 0.1)

.footer__social-networks
	font-family: 'Bernini Sans', 'Helvetica Neue', Helvetica, Arial, serif
	font-weight: 400
	font-style: normal
	font-size: 14px
	line-height: 18px
	line-height: 24px
	color: rgba(255,255,255,0.75)
	display: flex
	align-items: center
	padding: 8px 0
	margin: -12px -12px 0 0

	> span
		display: block
		padding-right: 12px
		margin-right: auto

	> a
		display: flex
		align-items: center
		justif-content: center
		padding: 12px
		color: #FFFFFF
		transition: all 120ms cubic-bezier(0.4, 0.0, 0.2, 1)
</style>
